export const HOST = 'wss://ws.reoserv.net';
export const TILE_WIDTH = 64;
export const TILE_HEIGHT = 32;
export const HALF_TILE_WIDTH = TILE_WIDTH >> 1;
export const HALF_TILE_HEIGHT = TILE_HEIGHT >> 1;

export const CHARACTER_HEIGHT = 58;

export const WALK_WIDTH_FACTOR = HALF_TILE_WIDTH / 4;
export const WALK_HEIGHT_FACTOR = HALF_TILE_HEIGHT / 4;
export const WALK_TICKS = 4;
export const FACE_TICKS = 1;
export const SIT_TICKS = 4;
export const ATTACK_TICKS = 4;
export const RANGED_ATTACK_TICKS = 4;
export const DEATH_TICKS = 6;
export const ANIMATION_TICKS = 6;
export const MAX_CHALLENGE = 11_092_110;
export const MIN_USERNAME_LENGTH = 4;
export const MAX_USERNAME_LENGTH = 16;
export const MIN_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 12;
export const MIN_CHARACTER_NAME_LENGTH = 4;
export const MAX_CHARACTER_NAME_LENGTH = 12;
export const NPC_IDLE_ANIMATION_TICKS = 2;
export const DOOR_OPEN_TICKS = 25;
export const DOOR_HEIGHT = 110;
export const MAX_CHAT_LENGTH = 128;
export const CLEAR_OUT_OF_RANGE_TICKS = 8;
export const USAGE_TICKS = 500;
export const ATLAS_EXPIRY_TICKS = 500;
export const NUMBER_OF_EMOTES = 15;
export const EMOTE_ANIMATION_TICKS = 8;
export const INITIAL_IDLE_TICKS = 2500;
export const IDLE_TICKS = 250;
export const MAX_LOCKER_UPGRADES = 15;
export const LOCKER_UPGRADE_BASE_COST = 1000;
export const LOCKER_UPGRADE_COST_STEP = 1000;
export const LOCKER_MAX_ITEM_AMOUNT = 200;

export const HOTBAR_COOLDOWN_TICKS = 2;
export const TICKS_PER_CAST_TIME = 4;
export const SPELL_COOLDOWN_TICKS = 5;

export const PLAYER_MENU_WIDTH = 96;
export const PLAYER_MENU_HEIGHT = 137;
export const PLAYER_MENU_ITEM_HEIGHT = 15;
export const PLAYER_MENU_OFFSET_Y = 10;

export const NUMBER_OF_EFFECTS = 101;
export const SPLOOSHIE_EFFECT_ID = 9;
export const ADMIN_HIDE_EFFECT_ID = 25;
export const ADMIN_WARP_LEAVE_EFFECT_ID = 3;
export const ADMIN_WARP_ENTER_EFFECT_ID = 4;
export const ITEM_PROTECT_TICKS_NPC = 250;
export const ITEM_PROTECT_TICKS_PLAYER = 42; // It's actually 41.66666.. but it doesn't divide by 120ms

export const COLORS = {
  Nameplate: '#fff',
  NameplateIgnored: '#b9b9b9',
  NameplateFriend: '#fafad2',
  NameplateRare: '#f5c89c',
  NameplateLegendary: '#fff0a5',
  NameplateUnique: '#fff0a5',
  NameplateLore: '#fafad3',
  ChatBubbleBackground: '#fff',
  ChatBubble: '#101010',
  ChatBubbleBackgroundParty: '#dcc8aa',
};

export const MAX_HAIR_STYLE = 20;
export const MIN_HAIR_STYLE = 1;
export const MAX_HAIR_COLOR = 10;
export const MIN_HAIR_COLOR = 0;
export const MAX_SKIN = 12;
export const MIN_SKIN = 0;
export const CREATE_CHARACTER_PREVIEW_PLAYER_ID = 4;
export const MAX_CHARACTERS = 3;

export const BARBER_BASE_COST = 200;
export const BARBER_COST_PER_LEVEL = 200;

export const GUILD_MIN_DEPOSIT = 1000;
export const GUILD_RANK_LEADER = 1;
export const GUILD_RANK_NEW_MEMBER = 9;
export const GUILD_MAX_RANK = 9;

export const JUKEBOX_COST = 25;

export const MARRIAGE_APPROVAL_COST = 500;
export const DIVORCE_COST = 10000;

export const GOLD_ITEM_ID = 1;

export const DEFRAG_FILL_THRESHOLD = 0.85;

// TODO: This should be in eo-protocol
export const BARD_EMOTE_ID = 15;

export const LOCKER_BASE_SLOTS = 100;
export const LOCKER_SLOTS_PER_UPGRADE = 10;
